import React, { useEffect, useMemo, useState } from 'react';

import PageHeader from '../../../components/PageHeader/PageHeader';
import ProductsTable from '../../../components/ProductsTable/ProductsTable';
import CategoriesTable from '../../../components/Category/CategoriesTable';
import StockReplenishmentsTable from '../../../components/Reposition/StockReplenishmentsTable';
import { Tabs, Tab, Box } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomTabPanel from './../../../components/Tab/CustomTabPanel';
import { categoryOptions, permissionOptions } from '../../../utils/Enums';
import { useParams } from 'react-router-dom';
import BulkImportButton from '../../../components/BulkImport/BulkImportButton';

export default function Products() {
  
  const { t } = useTranslation();
  const { locationId } = useParams();
  const [tabValue, setTabValue] = useState(0);

  const userPermissions = JSON.parse(localStorage.getItem('permissions')) || [];
  const hasPermission = (permissionId) => userPermissions.includes(permissionId);
  const canManageRetailReplenishments = hasPermission(
    permissionOptions.find((p) => p.label === 'REPLENISHMENT_RETAIL_PRODUCTS').id
  );
  const canManageCategories = ['CREATE_CATEGORY', 'UPDATE_CATEGORY', 'DELETE_CATEGORY'].some((permissionLabel) =>
    hasPermission(permissionOptions.find(p => p.label === permissionLabel).id)
  );

  const tabs = useMemo(() => {
    const items = [];
    items.push({
      key: 'products',
      label: t('products'),
      content: (
        <>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 2 }}>
            <PageHeader title={t('products')} subtitle={t('manage_products')} />
            <BulkImportButton type="products" label={t('products')} onSuccess={() => window.location.reload()} />
          </Box>
          <ProductsTable locationId={locationId} isBranch={false}/>
        </>
      )
    });
    if (canManageCategories) {
      items.push({
        key: 'categories',
        label: t('category_product'),
        content: (
          <>
            <PageHeader title={t('category')} subtitle={t('category_header')} />
            <CategoriesTable categoryType={ categoryOptions.PRODUCTS } />
          </>
        )
      });
    }
    if (canManageRetailReplenishments) {
      items.push({
        key: 'replenishment',
        label: t('replenishment'),
        content: (
          <>
            <PageHeader title={t('replenishment')} subtitle={t('replenishment_header')} />
            <StockReplenishmentsTable locationId={locationId} replenishmentCategory={2} />
          </>
        )
      });
    }
    return items;
  }, [canManageCategories, canManageRetailReplenishments, locationId, t]);

  useEffect(() => {
    if (tabValue >= tabs.length) {
      setTabValue(Math.max(0, tabs.length - 1));
    }
  }, [tabValue, tabs.length]);

  const handleChangeTab = (event, newValue) => {
    setTabValue(newValue);
  };

  return (
    <div>
      <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
        <Tabs value={tabValue} onChange={handleChangeTab} aria-label="basic tabs example">
          {tabs.map((tab) => (
            <Tab key={tab.key} label={tab.label} />
          ))}
        </Tabs>
      </Box>

      {tabs.map((tab, index) => (
        <CustomTabPanel key={tab.key} value={tabValue} index={index}>
          {tab.content}
        </CustomTabPanel>
      ))}
    </div>
  );
}
